<aside class="sidebar" [class.collapsed]="collapsed()">
  <div class="sidebar-header">
    <h4 *ngIf="!collapsed()"><i class="bi bi-shop"></i> TastyBytes</h4>
    <button class="sidebar-toggle" (click)="toggle()">
      <i [class]="collapsed() ? 'bi bi-list' : 'bi bi-x-lg'"></i>
    </button>
  </div>
  <nav>
    <ul class="nav-menu">
      <li class="nav-item">
        <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link">
          <i class="bi bi-speedometer2"></i>
          <span>Dashboard</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/accounts" routerLinkActive="active" class="nav-link">
          <i class="bi bi-person-badge"></i>
          <span>Accounts</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/orders" routerLinkActive="active" class="nav-link">
          <i class="bi bi-cart-check"></i>
          <span>Orders</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/inventory" routerLinkActive="active" class="nav-link">
          <i class="bi bi-box-seam"></i>
          <span>Inventory</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/ledger" routerLinkActive="active" class="nav-link">
          <i class="bi bi-journal-bookmark"></i>
          <span>Stock Ledger</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/accounts-ledger" routerLinkActive="active" class="nav-link">
          <i class="bi bi-cash-stack"></i>
          <span>Accounts Ledger</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/vendors" routerLinkActive="active" class="nav-link">
          <i class="bi bi-truck"></i>
          <span>Vendor Management</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/purchase-orders" routerLinkActive="active" class="nav-link">
          <i class="bi bi-file-earmark-text"></i>
          <span>Purchase Orders</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/recipes" routerLinkActive="active" class="nav-link">
          <i class="bi bi-journal-text"></i>
          <span>Recipe Cards</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/food-planning" routerLinkActive="active" class="nav-link">
          <i class="bi bi-calendar-check"></i>
          <span>Food Production</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/menu" routerLinkActive="active" class="nav-link">
          <i class="bi bi-menu-button-wide"></i>
          <span>Menu Items</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/counter" routerLinkActive="active" class="nav-link">
          <i class="bi bi-ticket-detailed-fill"></i>
          <span>Counter Operations</span>
        </a>
      </li>

      <li class="nav-item">
        <a routerLink="/reports" routerLinkActive="active" class="nav-link">
          <i class="bi bi-graph-up"></i>
          <span>Reports</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/broadcast" routerLinkActive="active" class="nav-link">
          <i class="bi bi-broadcast"></i>
          <span>Broadcast</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/users" routerLinkActive="active" class="nav-link">
          <i class="bi bi-people"></i>
          <span>User Management</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/settings" routerLinkActive="active" class="nav-link">
          <i class="bi bi-gear"></i>
          <span>Settings</span>
        </a>
      </li>
    </ul>
  </nav>
</aside>
